import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../Navbar";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
// import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import axios from "axios";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik, useFormik } from "formik";

import { createTheme, ThemeProvider } from "@mui/material/styles";
// import ChooseFile from "./ChooseFile";
import { withRouter } from "react-router-dom";
// import Blacklist from "./BlackList";
// import BulkUpload from "./BulkUpload";
// import Blacklist from "../Blacklisting/Blacklist";
// import NumberList from "../Blacklisting/Numberlist";
import BlockIcon from "@mui/icons-material/Block";
import Medium from "./Medium";
import ChannelMaster from "./Channel-Master";

function MainBlacklisting() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div className="card mb-3">
                <div className="card-header p-3 pt-2">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                    <i className="material-icons opacity-10">person</i>
                  </div>

                  <div class="pt-1 marginleft_0">
                    <p class="text-sm mb-0 text-capitalize fw-bold">
                      MEDIUM MASTER
                    </p>
                    <p className="text-sm mb-0  text d-inline-block float-end">
                      Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div>
                  <div className="text-end pt-1"></div>
                </div>
                <div className="card-body">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item  list_1" role="presentation">
                      <button
                        className="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#AccountDetails"
                        type="button"
                        role="tab"
                        aria-controls="AccountDetails"
                        aria-selected="true"
                      >
                        Medium Master
                      </button>
                    </li>
                    <li className="nav-item list_1" role="presentation">
                      <button
                        className="nav-link ms-2"
                        id="SenderMasking-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#SenderMasking"
                        type="button"
                        role="tab"
                        aria-controls="SenderMasking"
                        aria-selected="false"
                      >
                        Channel Master
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="AccountDetails"
                      role="tabpanel"
                      aria-labelledby="AccountDetails-tab"
                    >
                      <div>
                        {/* <Blacklist /> */}
                        <Medium />
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="SenderMasking"
                      role="tabpanel"
                      aria-labelledby="SenderMasking-tab"
                    >
                      <ChannelMaster />
                    </div>
                    <div
                      className="tab-pane fade "
                      id="ContactDetails"
                      role="tabpanel"
                      aria-labelledby="AccountDetails-tab"
                    >
                      {/* <NumberList /> */}
                    </div>
                    <div
                      className="tab-pane fade"
                      id="ServiceDetails"
                      role="tabpanel"
                      aria-labelledby="ServiceDetails-tab"
                    >
                      {/* <SubServiceDetails /> */}
                    </div>

                    <div
                      className="tab-pane fade"
                      id="ContactDetails"
                      role="tabpanel"
                      aria-labelledby="ContactDetails-tab"
                    >
                      {/* <SubContactDetails /> */}
                    </div>

                    <ThemeProvider theme={theme}>
                      <div
                        className="tab-pane fade"
                        id="LoginIPDetails"
                        role="tabpanel"
                        aria-labelledby="LoginIPDetails-tab"
                      >
                        <form
                          // onSubmit={formik.handleSubmit}
                          role="form"
                          className="text-start mt-5"
                        ></form>
                      </div>
                    </ThemeProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default withRouter(MainBlacklisting);
